var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.8333H5.00002C4.50002 10.8333 4.16669 10.5 4.16669 9.99999C4.16669 9.49999 4.50002 9.16666 5.00002 9.16666H15C15.5 9.16666 15.8334 9.49999 15.8334 9.99999C15.8334 10.5 15.5 10.8333 15 10.8333Z",
    fill: "#2C3038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.8333H7.50002C7.00002 15.8333 6.66669 15.5 6.66669 15C6.66669 14.5 7.00002 14.1667 7.50002 14.1667H12.5C13 14.1667 13.3334 14.5 13.3334 15C13.3334 15.5 13 15.8333 12.5 15.8333Z",
    fill: "#2C3038"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.83332H2.50002C2.00002 5.83332 1.66669 5.49999 1.66669 4.99999C1.66669 4.49999 2.00002 4.16666 2.50002 4.16666H17.5C18 4.16666 18.3334 4.49999 18.3334 4.99999C18.3334 5.49999 18 5.83332 17.5 5.83332Z",
    fill: "#2C3038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/SortIcon.477c601ec1f6394af421e0f814fb179b.svg";
export { ForwardRef as ReactComponent };